import { render } from "./Preferences.vue?vue&type=template&id=309c7fb8"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"
script.render = render

export default script